import { ReactNode } from 'react';
import { RdcGroupList } from './RdcGroupList';

export type ExtendedGroupType = {
	[groupKey: string]: boolean;
};

export type RdcGroupType = {
	/** Иконка пункта меню ( опционально ) */
	icon?: ReactNode;
	groupId: string;
	count: number;
	groupTitle?: string;
	page: number;
	list: Array<RdcGroupType> | Array<RdcGroupItemType | any>;
};

export type RdcGroupItemType = {
	id: string;
	title: string;
	icon?: string;
	isFavorite?: boolean;
};

export default RdcGroupList;
